
export const RM_TIME_RANGE_7_DAYS = 7;
export const RM_TIME_RANGE_30_DAYS = 30;
export const RM_TIME_RANGE_90_DAYS = 90;
